import React from "react";
import { useTranslation } from "react-i18next";
import { UseMutationResult } from "@tanstack/react-query";
import {
  getOnlySpecificErrorKey,
  getResponseErrorKey,
  ResponseError,
} from "../api/ResponseError";
import styles from "../../../pages/Landing/LandingPage.module.scss";
import { useProfileStore } from "../../initialRegistration/profileStore";
import { useShallow } from "zustand/react/shallow";
import { ErrorMessage } from "../../../components/ErrorMessage";

type ServerErrorProps = {
  // For now is any from design, during time it seems that this component is not a great idea
  // we should remove it and show separate errors based on the mutation
  // https://mtsemea.atlassian.net/browse/OA-6218
  /* eslint-disable @typescript-eslint/no-explicit-any */
  mutations: UseMutationResult<unknown, ResponseError, any>[];
};
export const ServerErrorHandler = ({ mutations }: ServerErrorProps) => {
  const { t } = useTranslation();
  const isPhoneNumberPinVerificationRequired = useProfileStore(
    useShallow((state) => state.isPhoneNumberPinVerificationRequired)
  );

  const isUnexpectedError = (error: ResponseError) =>
    !getOnlySpecificErrorKey(error);

  const getErrorMessage = (error: ResponseError) => {
    if (!isPhoneNumberPinVerificationRequired) {
      return (
        <ErrorMessage className={styles.serverError} key={error?.message}>
          {t(getResponseErrorKey(error) ?? "UNEXPECTED_EXCEPTION")}
        </ErrorMessage>
      );
    }

    return (
      isUnexpectedError(error) && (
        <ErrorMessage className={styles.serverError} key={error?.message}>
          {t("UNEXPECTED_EXCEPTION")}
        </ErrorMessage>
      )
    );
  };

  return (
    <>
      {mutations
        .filter((mutation) => mutation.isError)
        .map((mutation) => getErrorMessage(mutation.error))}
    </>
  );
};
